// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"index_modalContent__In4qQ","titleContainer":"index_titleContainer__Ai4Eh","formContent":"index_formContent__LHq5F","submitBtn":"index_submitBtn__rHxeK"};